
document.addEventListener('DOMContentLoaded', function () {
  let divs = document.querySelectorAll('.productDetailsDivSpan');

  // Loop through each div
  divs.forEach(function (div) {
    // Check if the div contains a span with specific text
    let keySpan = div.querySelector('.detailKey');
    if (keySpan) {
      let textContent = keySpan.textContent.trim();
      
      // Hide the div if it contains PDF, install_guide, user_guide, instruction_sheet, or technical_brochure information
      if (textContent.startsWith('pdf') || 
          textContent.includes('install_guide') || 
          textContent.includes('user_guide') || 
          textContent.includes('instruction_sheet') ||
          textContent.includes('data_sheet') ||
           textContent.includes('manual') ||
           textContent.includes('templates') ||
          textContent.includes('video') ||
          textContent.includes('warranty_sheet') ||    
          textContent.includes('technical_brochure')) {
        div.style.display = 'none';
      }
    }
  });
});



  document.addEventListener('DOMContentLoaded', function () {
    // Find the product__attribute for Manufacturer in productDescriptionDiv
    let manufacturerAttribute = document.querySelector(
      '.productDescriptionDiv .product__attribute span.product__attribute-type');

    // Ensure the manufacturerAttribute exists and its text content is 'Manufacturer'
    if (manufacturerAttribute && manufacturerAttribute.textContent.trim() === 'Manufacturer') {
      let manufacturerValue = manufacturerAttribute.nextElementSibling.textContent.trim();

      // Create new elements for the key-value pair in productDetailsTable
      let keySpan = document.createElement('span');
      keySpan.className = 'detailKey detailDiv';
      keySpan.textContent = 'Manufacturer: ';

      let valueSpan = document.createElement('span');
      valueSpan.className = 'detailDiv detailValue';
      valueSpan.textContent = manufacturerValue;

      let detailDiv = document.createElement('div');
      detailDiv.className = 'productDetailsDivSpan';
      detailDiv.appendChild(keySpan);
      detailDiv.appendChild(valueSpan);

      // Append the new element to productDetailsTable
      let productDetailsTable = document.querySelector('.productDetailsTable');
      if (productDetailsTable) {
        productDetailsTable.appendChild(detailDiv);
      }

      // Remove the original product__attribute from productDescriptionDiv if needed
      let productAttributeToRemove = document.querySelector('.productDescriptionDiv .product__attribute');
      if (productAttributeToRemove) {
        productAttributeToRemove.remove();
      }
    }
  });



document.addEventListener("DOMContentLoaded", function() {
    const description = document.querySelector(".product__description");
    const content = description.innerHTML;
    const lineHeight = parseFloat(getComputedStyle(description).lineHeight);
    const maxHeight = 10 * lineHeight;

    if (description.scrollHeight > maxHeight) {
        description.style.maxHeight = maxHeight + "px";
        description.style.overflow = "hidden";
        const readMoreBtn = document.createElement("button");
        readMoreBtn.textContent = "Read more";
        readMoreBtn.classList.add("read-more-btn"); // Add class to the button
        description.parentNode.insertBefore(readMoreBtn, description.nextSibling);

        readMoreBtn.addEventListener("click", function() {
            if (description.style.maxHeight === "none") {
                description.style.maxHeight = maxHeight + "px";
                readMoreBtn.textContent = "Read more";
            } else {
                description.style.maxHeight = "none";
                readMoreBtn.textContent = "Read less";
            }
        });
    }
});
